/**
 * グループ色のキーボードショートカット（グループエリアホバー時）
 * パウチ色と排他（ホバーはどちらか一方のみ）
 */

/** 単色指定: キー（小文字1文字）→ GROUP_COLORS の id */
export const GROUP_COLOR_HOTKEY_TO_ID: Record<string, string> = {
  y: 'yellow',
  g: 'green',
  b: 'blue',
  p: 'purple',
  r: 'red',
  w: 'gray',
};

/** ツールチップ表示順（GROUP_COLORS と同順） */
export const GROUP_COLOR_HOTKEY_DISPLAY_ORDER: { letter: string; colorId: string }[] = [
  { letter: 'Y', colorId: 'yellow' },
  { letter: 'G', colorId: 'green' },
  { letter: 'B', colorId: 'blue' },
  { letter: 'P', colorId: 'purple' },
  { letter: 'R', colorId: 'red' },
  { letter: 'W', colorId: 'gray' },
  /** ミュート（他と同様キー＋記号のみ、W の直後） */
  { letter: 'M', colorId: 'mute' },
];

export type GroupColorHotkeyAction =
  | { type: 'rotate'; reverse: boolean }
  | { type: 'direct'; colorId: string }
  | { type: 'muteToggle' };

export function resolveGroupColorHotkey(e: KeyboardEvent): GroupColorHotkeyAction | null {
  if (e.ctrlKey || e.metaKey || e.altKey) {
    return null;
  }
  if (e.key.length !== 1) {
    return null;
  }
  const ch = e.key.toLowerCase();
  if (ch === 'c') {
    return { type: 'rotate', reverse: e.shiftKey };
  }
  if (ch === 'm') {
    return { type: 'muteToggle' };
  }
  const colorId = GROUP_COLOR_HOTKEY_TO_ID[ch];
  if (colorId) {
    return { type: 'direct', colorId };
  }
  return null;
}
